const getScrollPositionOfPage = () => window.pageYOffset;

export default getScrollPositionOfPage;
